
// import React, { useState } from 'react';
// import './Login.css';
// import { FaUser, FaLock, FaEnvelope } from 'react-icons/fa';
// import { FcGoogle } from 'react-icons/fc';
// import { auth, googleProvider } from '../firebase/firebaseConfig';
// import { signInWithEmailAndPassword, createUserWithEmailAndPassword, signInWithPopup } from 'firebase/auth';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../auth/AuthContext';

// const LoginModal = ({ onClose }) => {
//   const [isActive, setIsActive] = useState(false);
//   const [formData, setFormData] = useState({ email: '', password: '', username: '' });
//   const navigate = useNavigate();
//   const { user } = useAuth();

//   const handleRegisterClick = () => {
//     setIsActive(true);
//   };

//   const handleLoginClick = () => {
//     setIsActive(false);
//   };

//   const handleChange = (e) => {
//     setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const { email, password } = formData;

//     try {
//       if (!isActive) {
//         await signInWithEmailAndPassword(auth, email, password);
//       } else {
//         await createUserWithEmailAndPassword(auth, email, password);
//       }al
//       onClose(); // Close modal on success
//       navigate('/profile');
//     } catch (error) {
//       alert(error.message);
//     }
//   };

//   const handleGoogleSignIn = async () => {
//     try {
//       await signInWithPopup(auth, googleProvider);
//       onClose(); // Close modal on success
//       navigate('/profile');
//     } catch (error) {
//       alert(error.message);
//     }
//   };

//   if (user) return null;

//   return (
//     <div className={`container ${isActive ? 'active' : ''}`}>
//       {/* <button
//         onClick={onClose}
//         style={{
//           position: 'absolute',
//           top: 20,
//           right: 20,
//           fontSize: '24px',
//           background: 'transparent',
//           border: 'none',
//           cursor: 'pointer',
//           color: '#333',
//           zIndex: 10
//         }}
//       >
//         &times;
//       </button> */}
//       <button
//         onClick={onClose}
//         style={{
//           position: 'absolute',
//           top: '10px',
//           right: '12px',
//           fontSize: '32px',
//           background: 'transparent',
//           border: 'none',
//           cursor: 'pointer',
//           color: '#000000', // black color
//           zIndex: 1000
//         }}
//       >
//         &times;
//       </button>


//       <div className="form-box login">
//         <form onSubmit={handleSubmit}>
//           <h1>Login</h1>
//           <div className="input-box">
//             <input 
//               type="email" 
//               placeholder="Email" 
//               name="email" 
//               value={formData.email}
//               onChange={handleChange}
//               required 
//             />
//             <FaEnvelope className="icon" />
//           </div>
//           <div className="input-box">
//             <input 
//               type="password" 
//               placeholder="Password" 
//               name="password" 
//               value={formData.password}
//               onChange={handleChange}
//               required 
//             />
//             <FaLock className="icon" />
//           </div>
//           <div className="forgot-link">
//             <a href="#">Forgot Password?</a>
//           </div>
//           <button type="submit" className="btn">Login</button>
//           <p>or login with social platforms</p>
//           <div className="social-icons">
//             <button type="button" onClick={handleGoogleSignIn}>
//               <FcGoogle className="icon" />
//             </button>
//           </div>
//         </form>
//       </div>

//       <div className="form-box register">
//         <form onSubmit={handleSubmit}>
//           <h1>Registration</h1>
//           <div className="input-box">
//             <input 
//               type="email" 
//               placeholder="Email" 
//               name="email" 
//               value={formData.email}
//               onChange={handleChange}
//               required 
//             />
//             <FaEnvelope className="icon" />
//           </div>
//           <div className="input-box">
//             <input 
//               type="password" 
//               placeholder="Password" 
//               name="password" 
//               value={formData.password}
//               onChange={handleChange}
//               required 
//             />
//             <FaLock className="icon" />
//           </div>
//           <button type="submit" className="btn">Register</button>
//           <p>or register with social platforms</p>
//           <div className="social-icons">
//             <button type="button" onClick={handleGoogleSignIn}>
//               <FcGoogle className="icon" />
//             </button>
//           </div>
//         </form>
//       </div>

//       <div className="toggle-box">
//         <div className="toggle-panel toggle-left">
//           <h1>Hello, Welcome!</h1>
//           <p>Don't have an account?</p>
//           <button className="btn" onClick={handleRegisterClick}>Register</button>
//         </div>

//         <div className="toggle-panel toggle-right">
//           <h1>Welcome Back!</h1>
//           <p>Already have an account?</p>
//           <button className="btn" onClick={handleLoginClick}>Login</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginModal;

import React, { useState, useEffect } from 'react';
import './Login.css';
import { FaLock, FaEnvelope } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import { auth, db, googleProvider } from '../firebase/firebaseConfig';
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
  sendEmailVerification,
  sendPasswordResetEmail
} from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { usePopup } from '../context/PopupContext';



const LoginModal = ({ onClose }) => {
  const [isActive, setIsActive] = useState(false);
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [verifying, setVerifying] = useState(false);
  const [resendVisible, setResendVisible] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(0);
  const [intervalId, setIntervalId] = useState(null);
  const [showReset, setShowReset] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const { showPopup } = usePopup();
  

  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const saved = localStorage.getItem('pendingCredentials');
    if (saved) {
      const { email, password } = JSON.parse(saved);
      setFormData({ email, password });
      setIsActive(false);
      setTimeout(() => {
        // alert("Email verified successfully! Please log in.");
        showPopup("Email verifies successfully! Please log in.");

      }, 300);
      localStorage.removeItem('pendingCredentials');
    }
  }, []);

  useEffect(() => {
    if (resendCooldown > 0) {
      const timer = setTimeout(() => setResendCooldown(resendCooldown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendCooldown]);

  const resetState = () => {
    setFormData({ email: '', password: '' });
    setVerifying(false);
    setResendVisible(false);
    setResendCooldown(0);
    if (intervalId) clearInterval(intervalId);
  };

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = formData;

    try {
      if (!isActive) {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        const currentUser = userCredential.user;

        if (!currentUser.emailVerified) {
          // alert("Please verify your email before logging in.");
          showPopup("Please verify your email before logging in.");

          return;
        }

        await setDoc(doc(db, "users", currentUser.uid), {
          email: currentUser.email,
          isVerified: true,
          createdAt: new Date()
        }, { merge: true });

        onClose();
        navigate('/');
        window.location.reload();
      } else {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const newUser = userCredential.user;

        await sendEmailVerification(newUser);
        // alert("Verification email sent to " + newUser.email);
        showPopup(`A verification email has been sent to ${newUser.email}.
            Please check your inbox (and spam folder), verify your email, and refresh the page to continue.`,10000);


        localStorage.setItem('pendingCredentials', JSON.stringify({ email, password }));
        setVerifying(true);

        let attempts = 0;
        const id = setInterval(async () => {
          await newUser.reload();
          if (newUser.emailVerified) {
            clearInterval(id);
            setIntervalId(null);
            // alert("Email verified successfully!");
            showPopup("Email verified successfully!");

            onClose();
            navigate('/');
            window.location.reload();
          } else {
            attempts++;
            if (attempts >= 3) {
              clearInterval(id);
              setIntervalId(null);
              setResendVisible(true);
              setResendCooldown(60);
            }
          }
        }, 3000);

        setIntervalId(id);
      }
    } catch (error) {
      // alert(error.message);
      showPopup(error.message);

    }
  };

  const resendVerificationEmail = async () => {
    if (resendCooldown > 0) return;
    try {
      const { email, password } = formData;
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      if (user.emailVerified) {
        // alert("Email is already verified!");
        showPopup("Email is already verified!");

        return;
      }

      await sendEmailVerification(user);
      // alert("Verification email resent to " + user.email);
      showPopup(`Verification email resent to ${user.email}`);

      setResendVisible(false);
      setResendCooldown(60);

      let attempts = 0;
      const id = setInterval(async () => {
        await user.reload();
        if (user.emailVerified) {
          clearInterval(id);
          await setDoc(doc(db, "users", user.uid), {
            email: user.email,
            isVerified: true,
            createdAt: new Date()
          }, { merge: true });
          // alert("Email verified successfully!");
          showPopup("Email verified successfully!");

          onClose();
          navigate('/');
          window.location.reload();
        } else {
          attempts++;
          if (attempts >= 3) {
            clearInterval(id);
            setResendVisible(true);
            setResendCooldown(60);
          }
        }
      }, 3000);

      setIntervalId(id);
    } catch (error) {
      // alert("Error resending email: " + error.message);
      showPopup("Error resending email: " + error.message);

    }
  };

  const handleRegisterClick = () => {
    setIsActive(true);
    resetState();
  };

  const handleLoginClick = () => {
    setIsActive(false);
    resetState();
  };

  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      await setDoc(doc(db, "users", user.uid), {
        email: user.email,
        isVerified: true,
        createdAt: new Date()
      }, { merge: true });

      onClose();
      navigate('/');
      window.location.reload();
    } catch (error) {
      // alert(error.message);
      showPopup("Error: " + error.message);

    }
  };

  const handlePasswordReset = async () => {
    if (!resetEmail) {
      // alert("Please enter your email.");
      showPopup("Please enter your email.");

      return;
    }

    try {
      await sendPasswordResetEmail(auth, resetEmail);
      // alert("Password reset email sent! Please check your inbox.");
      showPopup("Password reset email sent! Please check your inbox.");

      setShowReset(false);
      setResetEmail('');
    } catch (error) {
      // alert("Error: " + error.message);
      showPopup("Error: " + error.message);

    }
  };

  if (user) return null;

  return (
    <div className={`container ${isActive ? 'active' : ''}`}>
      <button className="close-button" onClick={onClose}>&times;</button>

      {/* Login Form */}
      <div className="form-box login">
        <form onSubmit={handleSubmit}>
          <h1>Login</h1>
          <div className="input-box">
            <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
            <FaEnvelope className="icon" />
          </div>
          <div className="input-box">
            <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} required />
            <FaLock className="icon" />
          </div>
          <p className="forgot-link">
            <span onClick={() => setShowReset(true)} style={{ cursor: 'pointer', color: '#581687' }}>
              Forgot Password?
            </span>
          </p>
          <button type="submit" className="btn">Login</button>
          <p>or login with social platforms</p>
          <div className="social-icons">
            <button type="button" onClick={handleGoogleSignIn}>
              <FcGoogle className="icon" />
            </button>
          </div>
        </form>
      </div>

      {/* Register Form */}
      <div className="form-box register">
        <form onSubmit={handleSubmit}>
          <h1>Registration</h1>
          <div className="input-box">
            <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required disabled={verifying} />
            <FaEnvelope className="icon" />
          </div>
          <div className="input-box">
            <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} required disabled={verifying} />
            <FaLock className="icon" />
          </div>
          <button type="submit" className="btn" disabled={verifying}>
            {verifying ? 'Verifying...' : 'Register'}
          </button>

          {resendVisible && (
            <div style={{ marginTop: '10px' }}>
              <button type="button" className="btn" onClick={resendVerificationEmail} disabled={resendCooldown > 0}>
                {resendCooldown > 0 ? `Resend in ${resendCooldown}s` : 'Resend Verification Email'}
              </button>
              <p style={{ marginTop: '10px' }}>
                Wrong Email? <span style={{ color: 'blue', cursor: 'pointer' }} onClick={resetState}>Change Email</span>
              </p>
            </div>
          )}

          <p>or register with social platforms</p>
          <div className="social-icons">
            <button type="button" onClick={handleGoogleSignIn}>
              <FcGoogle className="icon" />
            </button>
          </div>
        </form>
      </div>

      {/* Forgot Password Modal */}
      {showReset && (
        <div className="reset-modal">
          <div className="reset-content">
            <h2>Reset Your Password</h2>
            <input
              type="email"
              placeholder="Enter your email"
              value={resetEmail}
              onChange={(e) => setResetEmail(e.target.value)}
            />
            <div className="button-group">
              <button className="btn" onClick={handlePasswordReset}>Send Reset Link</button>
              <button className="btn" onClick={() => setShowReset(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}


      {/* Toggle Panel */}
      <div className="toggle-box">
        <div className="toggle-panel toggle-left">
          <h1>Hello, Welcome!</h1>
          <p>Don't have an account?</p>
          <button className="btn" onClick={handleRegisterClick}>Register</button>
        </div>
        <div className="toggle-panel toggle-right">
          <h1>Welcome Back!</h1>
          <p>Already have an account?</p>
          <button className="btn" onClick={handleLoginClick}>Login</button>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;

